/*
 * @Author: your name
 * @Date: 2020-10-14 16:07:59
 * @LastEditTime: 2020-11-06 11:45:55
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /yian-portal-wechat/src/main.js
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios-jsonp-pro'
import VueAxios from 'vue-axios'
import Util from './Util'
// import '../public/lib/vconsole2.5.1.min'

Vue.use(VueAxios, axios)

Vue.config.productionTip = false

function randomString(len) {
  len = len || 32
  var $chars =
    'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678' /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
  var maxPos = $chars.length
  var pwd = ''
  for (var i = 0; i < len; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos))
  }
  return pwd
}

axios.interceptors.request.use(
  (config) => {
    // if (reqArr.length === 0) {
    //   time = setTimeout(() => {
    //     loading = ElementUI.Loading.service({
    //       fullscreen: true
    //     })
    //   }, 800)
    // }
    // reqArr.push('axios')
    let token = Util.getCookie('charging_token')
    if (token) {
      config.headers.public_token = Util.getCookie('charging_token')
      axios.defaults.headers.common['public_token'] = token
    }
    if (Util.getCookie('parking_token')) {
      config.headers.token = Util.getCookie('parking_token')
      axios.defaults.headers.common['token'] = Util.getCookie('parking_token')
    }
    config.headers.no_commit = randomString(32)
    config.headers.req_from = 'APP-wxf33ef0a6e1194091'

    return config
  },
  (err) => {
    // closeLoading()
    return Promise.reject(err)
  }
)

axios.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error.response) {
      console.log(error.response.data.code)
      if (error.response.data.code == 401) {
        $.toast(error.response.data.data)
        Util.delCookie('charging_token')
        location.href = '/#/Login/'
      }
    }
    // return Promise.resolve(error.response)
  }
)

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
